import React from 'react';

// React-shared.
import { Input as SharedInput } from '@exonet/react-shared/lib/Form';

/**
 * Render a form input that password managers leave alone. Login and OTP use the
 * react-shared input directly and keep their fill menu.
 *
 * @param {Object} props All properties passed to the react-shared input.
 *
 * @return {Element} The rendered input.
 */
const Input = (props) => <SharedInput data-1p-ignore {...props} />;

export default Input;
